import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { OverlappingAvatars } from '@sorare/core/src/components/rivals/OverlappingAvatars';

import type { PastFixtureSelectorFooter_so5Fixture } from './__generated__/index.graphql';

type Props = {
  withMyCircleFooter?: boolean;
  so5Fixture: PastFixtureSelectorFooter_so5Fixture;
};

// Only handle withMyCircleFooter for now but allows scaling to other footers in the future (rewards, etc.)
export const PastFixtureSelectorFooter = ({
  withMyCircleFooter,
  so5Fixture,
}: Props) => {
  if (!so5Fixture || !withMyCircleFooter) {
    return null;
  }

  return (
    <OverlappingAvatars
      size={2}
      key={so5Fixture.slug}
      additionalPlayersCount={
        so5Fixture.myFriendsFixtureResultsPreview?.totalUsersCount -
        so5Fixture.myFriendsFixtureResultsPreview?.users.length
      }
      avatars={so5Fixture.myFriendsFixtureResultsPreview?.users.map(user => ({
        slug: user.slug,
        name: user.nickname,
        avatarUrl: user.pictureUrl,
      }))}
    />
  );
};

PastFixtureSelectorFooter.fragments = {
  so5Fixture: gql`
    fragment PastFixtureSelectorFooter_so5Fixture on So5Fixture {
      slug
      myFriendsFixtureResultsPreview {
        totalUsersCount
        users {
          slug
          nickname
          pictureUrl
        }
      }
    }
  ` as TypedDocumentNode<PastFixtureSelectorFooter_so5Fixture>,
};
